import { render, staticRenderFns } from "./SalesComparison.vue?vue&type=template&id=03d5a315&scoped=true"
import script from "./SalesComparison.vue?vue&type=script&lang=js"
export * from "./SalesComparison.vue?vue&type=script&lang=js"
import style0 from "./SalesComparison.vue?vue&type=style&index=0&id=03d5a315&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d5a315",
  null
  
)

export default component.exports